import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { DateTime } from "luxon";
import { Box } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { postData, getData } from '../../../webService/webservice.js'
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from "@iconify/icons-mdi/trash-can";
import "../../../styles/Auth/purchaseReturn.css";
const PurchaseReturn = ({ filters }) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [PurchaseReturns, setPurchaseReturns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [refreshKey, setRefreshKey] = useState(0);


    const fetchPurchaseReturns = async (page, limit, searchQuery, filters = {}) => {
        const params = {
            page,
            limit,
            search: searchQuery || "",
        };
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        try {
            setLoading(true);
            const response = await getData('purchasereturns/purchasereturns', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const purchaseList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;
            setPurchaseReturns(purchaseList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Purchases");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPurchaseReturns(currentPage, limit, searchQuery, filters);
    }, [currentPage, limit, refreshKey, searchQuery, filters]);

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };

    const headings = [
        "SL",
        "Return Date",
        "Product",
        "Quantity",
        "Rate",
        "Return Amount",
        "Reason"
    ];

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    return (
        <div className="purchaseReturn-layout1">
            <div className="purchaseReturn-content1">
                <main className="purchaseReturn-main1">
                    <>
                        <div className="purchaseReturn-widgets">
                            <div className="purchaseReturn-widgets-header">
                                <h3>Purchase Returns</h3>
                                {/* <input
                                    type="text"
                                    placeholder="Search"
                                    className="purchaseReturn-search-input"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                /> */}
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#E6CF80',
                                                        zIndex: 1,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {PurchaseReturns.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={10}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: "center",
                                                            padding: "20px",
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        No purchase returns found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            PurchaseReturns.map((purchaseReturn, index) => {
                                                const returnItem = purchaseReturn.returnItems?.[0]; // assuming one item per return

                                                return (
                                                    <TableRow key={purchaseReturn._id}>

                                                        {/* SL */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                        </TableCell>

                                                        {/* Return Date */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {DateTime.fromISO(purchaseReturn.createdAt).toFormat("dd LLL yyyy")}
                                                            </Typography>
                                                        </TableCell>
                                                    
                                                        {/* Product ID (or Name if you fetch separately) */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {purchaseReturn?.productDetails?.[0]?.title || "—"}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Quantity */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {returnItem?.qty || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Rate */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                ₹{returnItem?.rate?.toLocaleString() || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Return Amount */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                ₹{purchaseReturn?.totalAmount?.toLocaleString() || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Reason */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {purchaseReturn?.reason || "—"}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Actions */}
                                                        {/* <TableCell>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    gap: 2,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <Icon icon={plusIcon} width={20} height={20} />
                                                                <Icon icon={editIcon} width={20} height={20} />
                                                                <Icon icon={deleteIcon} width={20} height={20} style={{ color: "red" }} />
                                                            </Box>
                                                        </TableCell> */}
                                                    </TableRow>
                                                );
                                            })
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                            <div className="purchase-bottom">
                                <div className="purchase-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="purchase-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="purchase-section spacer"></div>
                                <div className="purchase-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                        </div>
                    </>
                </main>
            </div>
        </div>
    )
};

export default PurchaseReturn;